/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import dayjs from 'dayjs';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

const validationInformationsDissolution = (
    data: any,
) => {
    const errors = {
        motifDissolution: '',
        dateDissolution: '',
        dateMariage: '',
        dateDeces: '',
        dateDecision: '',
        dateDeclaration: '',
    };

    // Motif de dissolution (dropdown)
    if (_.isNil(data?.conventionDeclaration?.identifiantTypeDissolution) || !_.isFinite(data?.conventionDeclaration?.identifiantTypeDissolution)) {
        errors.motifDissolution = 'Le motif de dissolution est obligatoire';
    }

    // Mariage des partenaires / Mariage partenaire 1 / Mariage partenaire 2
    if (data?.conventionDeclaration?.identifiantTypeDissolution >= 1 && data?.conventionDeclaration?.identifiantTypeDissolution <= 3) {
        if (_.isNil(data?.conventionDeclaration?.dateMariage) || _.isEmpty(data?.conventionDeclaration?.dateMariage)) {
            errors.dateMariage = 'La date de mariage est obligatoire';
        } else if (dayjs(data?.conventionDeclaration?.dateMariage).isAfter(dayjs())) {
            errors.dateMariage = 'La date de mariage ne peut pas être dans le futur';
        }
    }

    // Décès des partenaires
    if (data?.conventionDeclaration?.identifiantTypeDissolution === 4) {
        if (_.isNil(data?.conventionDeclaration?.partenaire1DateDeces) || _.isEmpty(data?.conventionDeclaration?.partenaire1DateDeces)) {
            errors.dateDeces = 'La date du décès du partenaire 1 est obligatoire';
        } else if (dayjs(data?.conventionDeclaration?.partenaire1DateDeces).isAfter(dayjs())) {
            errors.dateDeces = 'La date du décès du partenaire 1 ne peut pas être dans le futur';
        }
        if (_.isNil(data?.conventionDeclaration?.partenaire2DateDeces) || _.isEmpty(data?.conventionDeclaration?.partenaire2DateDeces)) {
            errors.dateDeces = 'La date du décès du partenaire 2 est obligatoire';
        } else if (dayjs(data?.conventionDeclaration?.partenaire2DateDeces).isAfter(dayjs())) {
            errors.dateDeces = 'La date du décès du partenaire 2 ne peut pas être dans le futur';
        }
    }

    // Décès du partenaire 1
    if (data?.conventionDeclaration?.identifiantTypeDissolution === 5) {
        if (_.isNil(data?.conventionDeclaration?.partenaire1DateDeces) || _.isEmpty(data?.conventionDeclaration?.partenaire1DateDeces)) {
            errors.dateDeces = 'La date du décès du partenaire 1 est obligatoire';
        } else if (dayjs(data?.conventionDeclaration?.partenaire1DateDeces).isAfter(dayjs())) {
            errors.dateDeces = 'La date du décès du partenaire 1 ne peut pas être dans le futur';
        }
    }

    // Décès du partenaire 2
    if (data?.conventionDeclaration?.identifiantTypeDissolution === 6) {
        if (_.isNil(data?.conventionDeclaration?.partenaire2DateDeces) || _.isEmpty(data?.conventionDeclaration?.partenaire2DateDeces)) {
            errors.dateDeces = 'La date du décès du partenaire 2 est obligatoire';
        } else if (dayjs(data?.conventionDeclaration?.partenaire2DateDeces).isAfter(dayjs())) {
            errors.dateDeces = 'La date du décès du partenaire 2 ne peut pas être dans le futur';
        }
    }

    // Décision unilatérale d'un partenaire / Décicision unilatérale à l'initiative d'un tuteur
    if (data?.conventionDeclaration?.identifiantTypeDissolution >= 7 && data?.conventionDeclaration?.identifiantTypeDissolution <= 10) {
        if (_.isNil(data?.conventionDeclaration?.dateDeclarationUnitDi) || _.isEmpty(data?.conventionDeclaration?.dateDeclarationUnitDi)) {
            errors.dateDeclaration = 'La date de décision unilatérale est obligatoire';
        } else if (dayjs(data?.conventionDeclaration?.dateDeclarationUnitDi).isAfter(dayjs())) {
            errors.dateDeclaration = 'La date de décision unilatérale ne peut pas être dans le futur';
        }
        if (_.isNil(data?.conventionDeclaration?.dateSignification) || _.isEmpty(data?.conventionDeclaration?.dateSignification)) {
            errors.dateDeclaration = 'La date de signification est obligatoire';
        } else if (dayjs(data?.conventionDeclaration?.dateSignification).isAfter(dayjs())) {
            errors.dateDeclaration = 'La date de signification ne peut pas être dans le futur';
        }
    }

    // Déclaration conjointe des partenaires / Déclaration conjointe à l'initiative d'un tuteur
    if (data?.conventionDeclaration?.identifiantTypeDissolution >= 11 && data?.conventionDeclaration?.identifiantTypeDissolution <= 12) {
        if (_.isNil(data?.conventionDeclaration?.dateDeclarationJointDi) || _.isEmpty(data?.conventionDeclaration?.dateDeclarationJointDi)) {
            errors.dateDeclaration = 'La date de déclaration conjointe est obligatoire';
        } else if (dayjs(data?.conventionDeclaration?.dateDeclarationJointDi).isAfter(dayjs())) {
            errors.dateDeclaration = 'La date de déclaration conjointe ne peut pas être dans le futur';
        }
    }

    // Date de dissolution
    if (_.isNil(data?.conventionDeclaration?.dateDissolution) || _.isEmpty(data?.conventionDeclaration?.dateDissolution)) {
        errors.dateDissolution = 'La date de dissolution est obligatoire';
    }

    return _.pickBy(errors, (value) => value !== '');
};

export default validationInformationsDissolution;
